import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TAppConfig, TAuthState, TGlobalError, TUser } from "@/types/public";
import { RootState } from "../../store";

const initialState: TAuthState = {
  jwt: null,
  uid: null,
  user: null,
  shortCode: null,
  global_error: null,
  app_config: null,
  config_loading: false,
  config_ready: false,
  config_error: null,
};

const slice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (
      state,
      action: PayloadAction<{
        user: TUser;
        shortCode: string;
        uid: string;
        jwt: string;
        gid: string;
        hash: string;
      }>
    ) => {
      const { user, jwt, shortCode, uid, gid, hash } = action.payload;
      state.user = { ...user, gv_id: gid, hash };
      state.jwt = jwt;
      state.shortCode = shortCode;
      state.uid = uid;
    },
    updateCredentials: (
      state,
      action: PayloadAction<{
        avatarUrl?: string;
        role?: string;
        room_name?: string;
        session_name?: string;
        subtitle?: string;
        gv_id?: string;
        hash?: string;
        pid?: string;
        wid?: string;
        exp?: string;
        cid?: string;
        approved?: boolean;
        isDone?: boolean;
        isPaused?: boolean;
      }>
    ) => {
      const { role, approved, isPaused, isDone } = action.payload;
      if (state.user && role !== undefined) state.user.role = role;
      if (state.user && isPaused !== undefined) state.user.isPaused = isPaused;
      if (state.user && isDone !== undefined) state.user.isDone = isDone;
      if (state.user && approved !== undefined) state.user.approved = approved;
    },
    setGlobalError: (state, action: PayloadAction<TGlobalError>) => {
      state.global_error = {
        errorCode: action.payload.errorCode,
        message: action.payload.message,
      };
    },
    clearGlobalError: (state) => {
      state.global_error = null;
    },
    setAppConfig: (state, action: PayloadAction<TAppConfig>) => {
      state.app_config = { ...action.payload };
    },
    clearAppConfig: (state) => {
      state.app_config = null;
    },
  },
});

export const {
  setCredentials,
  updateCredentials,
  setGlobalError,
  clearGlobalError,
  setAppConfig,
  clearAppConfig,
} = slice.actions;

export default slice.reducer;

export const selectCurrentAuth = (state: RootState) => state.auth;
